import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrialSubscriptionService {
  constructor(
    private http: HttpClient, 
    public commonFunction: CommonFunction, 
    private handler: HttpBackend
    ) 
    
{
    this.http = new HttpClient(handler);
}

// Helper method to get company headers
private getCompanyHeaders(): HttpHeaders {
    return new HttpHeaders({
        'Content-Type': 'application/json',
        'govevacompany': JSON.stringify({
            label: localStorage.getItem('CompanyName'),
            value: localStorage.getItem('ClientCompanyId')
        })
    });
}

addCompanyTrial(newCompany): Promise<any> {
  // Trim 'gapi/' from the nonValidateUrl for trial endpoints
  // const baseUrl = environment.nonValidateUrl.replace('/gapi/', '/');
  // const apiUrl = baseUrl + 'free-trial/company/add';

  const apiUrl = environment.nonValidateUrl + 'free-trial/company/add';

  return this.http.post(apiUrl, newCompany)
      .toPromise()
      .then(response => {
          return Promise.resolve(response);
      })
      .catch(error => {
          return Promise.reject(error);
      });
}


  // Add trial user
  addUserTrial(newUser): Promise<any> {
    // Trim 'gapi/' from the nonValidateUrl for trial endpoints
    // const baseUrl = environment.nonValidateUrl.replace('/gapi/', '/');
    // const apiUrl = baseUrl + 'free-trial/user/add';
    
    const apiUrl = environment.nonValidateUrl + 'free-trial/user/add';
    // Get headers using helper method
    const headers = this.getCompanyHeaders();
    return this.http.post(apiUrl, newUser, { headers })
      .toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  // Get trial users list
  getTrialUsersList(): Promise<any> {
    const apiUrl = environment.nonValidateUrl + 'trial-users';
    
    return this.http.get(apiUrl)
      .toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  // Update trial user by ID (public endpoint - no authentication required)
  updateTrialUser(userId: string, updateData: any): Promise<any> {
    const apiUrl = environment.nonValidateUrl + `trial-users/${userId}`;
    
    return this.http.patch(apiUrl, updateData)
      .toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  // Delete trial user by ID (public endpoint - no authentication required)
  deleteTrialUser(userId: string): Promise<any> {
    const apiUrl = environment.nonValidateUrl + `trial-users/${userId}`;
    
    return this.http.delete(apiUrl)
      .toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }
}
